import styled, { css } from 'styled-components';

import { breakpoints, InfoCircleIcon, theme } from '@notino/react-styleguide';
export const TagDiscountFlexRow = styled.div<{ newDesign: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  gap: 0.4rem;

  @media (min-width: ${breakpoints.md}) {
    margin-top: auto;
  }

  ${({ newDesign }) =>
    newDesign
      ? css`
          min-height: 2.5rem;
        `
      : css`
          height: 2.5rem;
          margin-bottom: 1rem;
        `}
`;

export const DiscountWrapper = styled.div`
  text-align: right;
  line-height: 1.25rem;
`;

export const OriginalPriceWrapper = styled.span<{ newDesign: boolean }>`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;

  ${({ newDesign }) =>
    newDesign
      ? css`
          color: ${theme.color.text.tertiary};
          ${theme.typography.labelRegular400}
        `
      : css`
          color: ${theme.color.text.secondary};
          padding-left: 0.625rem;
          font-weight: 300;
          font-size: 0.875rem;

          @media (min-width: ${breakpoints.sm}) {
            font-size: 0.8rem;
          }
        `}
`;

export const FlexEnd = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`;

export const LineThrough = styled.span<{ active: boolean }>`
  ${({ active }) => active && 'text-decoration: line-through'};
  white-space: nowrap;
`;

export const Discount = styled.span<{
  newDesign: boolean;
  isSmall: boolean;
}>`
  color: ${theme.color.text.highlight};

  ${({ newDesign, isSmall }) =>
    newDesign
      ? css`
          ${isSmall
            ? theme.typography.labelRegular
            : theme.typography.labelLarge}
        `
      : css`
          font-size: 0.875rem;
          font-weight: bold;
          text-transform: uppercase;

          @media (min-width: ${breakpoints.sm}) {
            font-size: 1.2rem;
          }
        `}
`;

export const PriceWrapper = styled.span`
  font-size: 0.8rem;
`;

export const CurrencyWrapper = styled(PriceWrapper)`
  ::before {
    content: ' ';
  }
`;

export const StyledInfoIcon = styled(InfoCircleIcon)`
  margin-bottom: 4px;
`;

export const Slash = styled.span`
  padding: 0 0.25rem;
`;
